// 0 - no print, 4 - CMYK, 1 - single color
export enum PrintSide {
  None = '0-0',
  Front = '4-0',
  Back = '0-4',
  Both = '4-4',
}
